import Vue from 'vue'
import Router from 'vue-router'
import About from '@/views/about/about'
import firstPage from '@/views/firstPage/firstPage'
import Articles from '@/views/articles/articles'
import LeaveMsg from '@/views/leave-msg/leave-msg'
import ArticleInfo from  '@/views/articleInfo/index.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: firstPage
    },
    {
      path: '/index',
      name: 'Index',
      component: firstPage
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/articles',
      name: 'Articles',
      component: Articles
    },
    {
      path: '/leave-msg',
      name: 'LeaveMsg',
      component: LeaveMsg
    },
    {
      path: '/articleInfo/:id',
      name: 'ArticleInfo',
      component: ArticleInfo
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js